export default "__VITE_ASSET__CgorjENp__"